import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import { notification } from 'antd';
import { connectToCollectionTitles } from './CollectionTitlesDataStore';

const CollectionsContext = React.createContext();

const name = 'collectionsDataStore';

export const connectToCollections = makeConnectTo(CollectionsContext, name);

export class CollectionsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		collections: {},
		areCollectionsLoading: true,
	};

	render() {
		const collectionsDataStore = this.getStore();
		return (
			<CollectionsContext.Provider value={collectionsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(collectionsDataStore)
					: this.props.children}
			</CollectionsContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchCollections();
	}

	componentWillUnmount() {
		if (this.collectionsFetch && this.collectionsFetch.cancel) {
			this.collectionsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshCollections(),
		addTitlesToCollection: (skus, catalogId) => this.addTitlesToCollection(skus, catalogId),
		createNewCollection: (name, skus) => this.createNewCollection(name, skus),
		editExistingCollection: (catalogId, fieldName, name) => this.editExistingCollection(catalogId, fieldName, name),
	});

	refreshCollections = () => {
		this.setState({
			areCollectionsLoading: true,
		});
		this.fetchCollections();
		return this.collectionsFetch.promise;
	};

	fetchCollections = () => {
		const request = api.cancelableGet(`/api/v1/me/collections`);
		request.promise.then(this.cacheApiResponse);
		this.collectionsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const collections = apiResponse && apiResponse;
		this.setState({ collections, areCollectionsLoading: false });
	};

	addTitlesToCollection = (skus, catalogId) => {
		api.post(`/api/v1/me/collections/${catalogId}`, skus).then(() => {
			this.refreshCollections();
		});
	};

	createNewCollection = (name, skus) => {
		var products = [];
		skus.forEach(sku => {
			products.push({
				sku: sku
			});
		});

		var collection = {
			type: 2,
			name: encodeURIComponent(name),
			products: products,
		};

		return api.put(`/api/v1/me/collections`, collection).then(() => {
			this.refreshCollections();
			this.props.collectionTitlesDataStore && this.props.collectionTitlesDataStore.refresh();
			notification.success({
				message: `Successfully created the '${name}' collection`,
			});
		});
	};

	editExistingCollection = (catalogId, fieldName, name) => {
		return api
			.put(
				`/api/v1/catalogs/${catalogId}/${fieldName}`,
				encodeURIComponent(name),
			)
			.then(() => {
				return this.refreshCollections();
			});
	};
}

export default connectToCollectionTitles(CollectionsDataStore);
